
import { RevLink } from '@ds/components/Link'

export default {
  components: {
    RevLink,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    headerHeight: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    anchor() {
      return this.link ? `#${this.link}` : ''
    },
  },
}
